/**
 * A type that represents either a single value or an array of values.
 *
 * @group Utils
 *
 * @beta
 */
export type ValueOrArray<T> = T | T[];
